import React from 'react'

const CardComp = ({ imgList, cardText, data, onBoxClick }) => {
    console.log(data,"data");
    
    const handleBoxClick = (type, value) => {
        if (onBoxClick) {
            onBoxClick(type, value);
        }
    };
    return (
        <div className='comonCard'>
            <div className='top'>
                <img src={imgList} alt="all" />
                <h2>{cardText}</h2>
            </div>
            <div className='bottom'>
                <div className={`${cardText === "Monthly" ? "addCursor box-wraper" : 'box-wraper' }`} onClick={() => handleBoxClick('Submitted', data?.submitted || 0)}>
                    <span className='box-value'>{data?.submitted || 0}</span>
                    <span className='box-name'>Submitted</span>
                </div>
                <div className={`${cardText === "Monthly" ? "addCursor box-wraper" : 'box-wraper' }`} onClick={() => handleBoxClick('Rejected', data?.rejected || 0)}>
                    <span className='box-value'>{data?.rejected || 0}</span>
                    <span className='box-name'>Rejected</span>
                </div>
                <div className={`${cardText === "Monthly" ? "addCursor box-wraper no-border" : 'box-wraper no-border' }`}  onClick={() => handleBoxClick('Opened', data?.accountCreated || 0)}>
                    <span className='box-value'>{data?.accountCreated || 0}</span>
                    <span className='box-name'>Opened</span>
                </div>
            </div>
        </div>
    )
}

export default CardComp